//service
import { getMatch } from "../../../utils/services/match";

export const excelColumnsPtBr = {
  "Email Hospede 1": "host_one",
  "Email Hospede 2": "host_two",
  "Email Hospede 3": "host_three",
  "Email Hospede 4": "host_four",
};

export function allExcelColumns(row, index) {
  const formatedRow = {
    index,
    host_one: row.host_one ? row.host_one : undefined,
    host_two: row.host_two ? row.host_two : "Vazio",
    host_three: row.host_three ? row.host_three : "Vazio",
    host_four: row.host_four ? row.host_four : "Vazio",
  };

  return formatedRow;
}

export function findRowsWithError(validRows) {
  const rowsWithError = validRows.filter((row) => row.host_one === undefined);

  return rowsWithError;
}

// pegar todos os usuários de todos os campos
async function getUsers(rows) {
  var allUser = [];

  rows.map((e) => {
    allUser.push(e.host_one);

    if (e.host_two && e.host_two != "Vazio") allUser.push(e.host_two);
    if (e.host_three && e.host_three != "Vazio") allUser.push(e.host_three);
    if (e.host_four && e.host_four != "Vazio") allUser.push(e.host_four);
  });

  return allUser;
}

export async function verifyUser(rows, users) {
  var allUsers = await getUsers(rows);

  var userNotFound = [];

  allUsers.map((e) => {
    const search = users.find((user) => user.email === e);

    if (!search) {
      userNotFound.push(e);
    }
  });

  var rowErro = [];

  rows.forEach((row) => {
    var currentRow = row;
    var changed = false;

    Object.keys(row).forEach((chave) => {
      if (userNotFound.includes(row[chave])) {
        currentRow[chave] = undefined;

        changed = true;
      }
    });

    if (changed) rowErro.push(currentRow);
  });

  return rowErro;
}

export async function verifyDuplicity(rows) {
  var allUser = await getUsers(rows);

  var uniqueUser = [];
  var duplicatedUser = [];

  // validar quais são repetidos
  allUser.forEach((element) => {
    const isDuplicate = uniqueUser.includes(element);

    if (!isDuplicate) {
      uniqueUser.push(element);
    } else if (isDuplicate && !duplicatedUser.find((e) => e === element)) {
      duplicatedUser.push(element);
    } else return;
  });

  var rowsUserDuplicated = [];

  // setar undefined nos campos com emails repetidos
  duplicatedUser.map((duplicated) => {
    rows.map((row) => {
      var rowDuplicated = row;
      var changed = false;

      Object.entries(row).forEach(([key, value]) => {
        if (value === duplicated) {
          rowDuplicated = {
            ...rowDuplicated,
            [key]: undefined,
          };

          changed = true;
        }
      });

      if (changed) rowsUserDuplicated.push(rowDuplicated);
    });
  });

  return rowsUserDuplicated;
}

export async function verifyRooms(rows, rooms) {
  const single = rooms.find((e) => e.descricao === "Single");
  const double = rooms.find((e) => e.descricao === "Duplo");
  const triple = rooms.find((e) => e.descricao === "Triplo");
  const quadruple = rooms.find((e) => e.descricao === "Quadruplo");

  const totalSingle = single ? single.disponivel : 0;
  const totalDouble = double ? double.disponivel : 0;
  const totalTriple = triple ? triple.disponivel : 0;
  const totalQuadruple = quadruple ? quadruple.disponivel : 0;

  var roomSingle = [];
  var roomDouble = [];
  var roomTriplo = [];
  var roomQuadruple = [];

  rows.map((e) => {
    if (e.host_four && e.host_four != "Vazio") {
      roomQuadruple.push(e);
    } else if (e.host_three && e.host_three != "Vazio") {
      roomTriplo.push(e);
    } else if (e.host_two && e.host_two != "Vazio") {
      roomDouble.push(e);
    } else {
      roomSingle.push(e);
    }
  });

  var roomError = [];

  if (roomSingle.length > totalSingle) {
    roomError.push("Single");
  }

  if (roomDouble.length > totalDouble) {
    roomError.push("Duplo");
  }

  if (roomTriplo.length > totalTriple) {
    roomError.push("Triplo");
  }

  if (roomQuadruple.length > totalQuadruple) {
    roomError.push("Quádruplo");
  }

  return roomError;
}

export async function verifyUserRegistered(rows, eventId) {
  const allMatch = await getAllMatch(eventId);

  var rowErro = [];

  rows.forEach((row) => {
    var currentRow = row;
    var changed = false;

    Object.keys(row).forEach((chave) => {
      if (allMatch.includes(row[chave])) {
        currentRow[chave] = undefined;

        changed = true;
      }
    });

    if (changed) rowErro.push(currentRow);
  });

  return rowErro;
}

async function getAllMatch(eventId) {
  var allData = [];

  await getMatch({
    eventId: eventId,
    limit: 100000000,
    offset: 1,
    search: "",
  }).then((res) => {
    if (res.count > 0) {
      res.data.map((e) => {
        allData.push(e.login_email_1);
        allData.push(e.login_email_2);

        if (e.login_email_3) allData.push(e.login_email_3);
        if (e.login_email_4) allData.push(e.login_email_4);
      });
    }
  });

  return allData;
}
